export default __webpack_public_path__ + "static/media/pedro.f75d63ac.jpg";